export const ChangePasswordLang = {
    oldPass: 'رمز عبور فعلی',
    newPass: 'رمز عبور جدید',
    re_oldPass: 'تکرار رمز عبور جدید',
    changePassword: 'تغییر رمز عبور',
    save: 'ذخیره',
    error: 'رمز عبور فعلی وارد شده صحیح نیست',
    success: 'رمز عبور شما با موفقیت بروزرسانی شد',
    inputPH: '********',
};
